export function notFilter(value: boolean){
    return !value;
}